import React from 'react';
import { GraduationCap, Clock, BookOpen, X, Check, Loader2, AlertCircle, RefreshCw } from 'lucide-react';
import { Course } from '../types';

interface CourseDisplayProps {
  items: Course[];
  onCancel: () => void;
}

export const CourseDisplay: React.FC<CourseDisplayProps> = ({ items, onCancel }) => {
  return (
    <div className="h-full flex flex-col bg-blue-50/50">
      <div className="flex-shrink-0 px-6 py-5 flex justify-between items-center bg-white border-b border-gray-100 shadow-sm z-10">
         <div className="flex items-center gap-3">
            <div>
               <h3 className="font-sans font-bold text-2xl text-gray-900 tracking-tight">Aziz Edu Programs</h3>
               <p className="text-xs text-blue-600 font-bold tracking-widest uppercase mt-1.5">Explore Available Programs</p>
            </div>
         </div>
         <button onClick={onCancel} className="p-2 hover:bg-gray-100 text-gray-400 hover:text-gray-600 rounded-full transition-all duration-300 transform hover:rotate-90">
            <X size={24} />
         </button>
      </div>

      <div className="flex-grow overflow-y-auto p-4 space-y-4 custom-scrollbar">
        {items.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-64 text-gray-400">
             <div className="bg-gray-100 p-6 rounded-full mb-4">
                 <GraduationCap size={48} className="opacity-20"/>
             </div>
             <p className="text-lg font-sans">No programs found.</p>
          </div>
        ) : (
          items.map((item, idx) => (
            <div
               key={item.id || idx}
               className="flex gap-4 p-4 bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 group animate-in slide-in-from-bottom-2 fade-in"
               style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <div className="w-28 h-28 flex-shrink-0 rounded-xl overflow-hidden bg-gray-100 relative shadow-inner flex items-center justify-center">
                <GraduationCap size={40} className="text-gray-300" />
              </div>
              <div className="flex-grow flex flex-col justify-between py-0.5">
                 <div>
                    <h4 className="font-sans font-bold text-gray-900 line-clamp-1 text-lg group-hover:text-blue-600 transition-colors">{item.name}</h4>
                    <p className="text-sm text-gray-600 line-clamp-2 mt-1 leading-relaxed">{item.description}</p>
                    <div className="flex flex-wrap gap-1.5 mt-2">
                        <span className="text-[10px] font-bold bg-blue-500/20 text-blue-600 px-2 py-0.5 rounded-full border border-blue-500/20">4 Years</span>
                        <span className="text-[10px] font-bold bg-green-100 text-green-700 px-2 py-0.5 rounded-full border border-green-200">{item.category}</span>
                    </div>
                 </div>
                 <div className="flex justify-between items-end mt-2">
                    <div>
                      <div className="flex items-center gap-1 text-sm text-gray-600">
                        <Clock size={14} />
                        <span>{item.duration || '4 Years (8 Semesters)'}</span>
                      </div>
                      <div className="text-sm text-gray-600">
                        <span>Min. 134 Credit Hours</span>
                      </div>
                    </div>
                 </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};